// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"2348581b","235":"05104d76","242":"8e8ccc22","607":"eeffa1d9","845":"fee20d5c","994":"2e8c3d1d"}[chunkId] + ".chunk.js";
};